export default __webpack_public_path__ + "static/open-sans-v15-latin-regular-ec806460121999bcfb12bc264d46d41e.woff2";